import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css']
})
export class DeleteComponent {
  //criar formulario
  deleteForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DeleteComponent>,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

    this.deleteForm = this._formBuilder.group({
      texto: ['', Validators.required],
  });

  }

  confirmar(): void{

    this.dialogRef.close(true);

  }


  fecharDialog(): void {
    this.dialogRef.close(false);
  }
}
